import { model as i18n } from '!/i18n'
import {
  api,
  type Page,
  type PageableInfo,
  type TvChannel,
} from '@setplex/tria-api'
import { combine, createEvent, createStore } from 'effector'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { genPagesLogic } from '~/shared/effector'
import { extendMediaItemByLabelPriceTvChannel } from '~/shared/tools'

export const resetOnlyFavoritesTvChannelsRow = createEvent()
export const $onlyFavoritesTvChannelsRow = createStore<Page<TvChannel> | null>(
  null
)
  .on(api.tv.getOnlyFavoritesTvChannelsRowFx.doneData, (_, page) => page)
  .on(ssePurchasesModel.$channel, (page, adjust) => {
    if (page == null) return page
    return {
      ...page,
      content: page.content.map((item) => adjust(item)),
    }
  })
  .reset(resetOnlyFavoritesTvChannelsRow)

export const $onlyFavoritesTvChannelsRowFormatted = combine(
  $onlyFavoritesTvChannelsRow,
  i18n.$t,
  (onlyFavoritesTvChannelsRow) => ({
    ...onlyFavoritesTvChannelsRow,
    content: onlyFavoritesTvChannelsRow?.content.map((item) =>
      extendMediaItemByLabelPriceTvChannel(item)
    ),
  })
)

export const resetOnlyFavoritesTvChannelsGrid = createEvent()
export const $onlyFavoritesTvChannelsGrid = createStore<Page<TvChannel> | null>(
  null
)
  .on(api.tv.getOnlyFavoritesTvChannelsGridFx.doneData, (state, page) => {
    const currentTvChannels = state
      ? [...state.content, ...page.content]
      : page.content

    return {
      ...page,
      content: currentTvChannels,
    }
  })
  .on(ssePurchasesModel.$channel, (page, adjust) => {
    if (page == null) return page
    return {
      ...page,
      content: page.content.map((item) => adjust(item)),
    }
  })
  .reset(resetOnlyFavoritesTvChannelsGrid)

export const $onlyFavoritesTvChannelsGridPageInfo =
  createStore<PageableInfo | null>(null).on(
    api.tv.getOnlyFavoritesTvChannelsGridFx.done,
    (
      _,
      { result: { content: _ignored, ...pageInfo }, params: { ...params } }
    ) => {
      return {
        ...pageInfo,
        params,
      }
    }
  )

export const $onlyFavoritesTvChannelsGridFormatted = combine(
  $onlyFavoritesTvChannelsGrid,
  i18n.$t,
  (onlyFavoritesTvChannelsGrid) => {
    const formattedPageContent = onlyFavoritesTvChannelsGrid?.content.map(
      (item) => extendMediaItemByLabelPriceTvChannel(item)
    )

    return {
      ...onlyFavoritesTvChannelsGrid,
      content: formattedPageContent,
    }
  }
)

export const loadMoreOnlyFavoritesTvChannelsGrid = genPagesLogic(
  $onlyFavoritesTvChannelsGridPageInfo,
  api.tv.getOnlyFavoritesTvChannelsGridFx
)
